import { TeamColumn } from "@common/types/views/teamViews";
import { ViewConfig } from "@lib/views";
import {
    OrganizationMember,
    OrganizationMemberWorkspaceAssignment,
} from "@common/dto/organization/organization-member.dto";
import { InviteCode } from "@common/types/inviteCode";
import { UserCell } from "./cells/UserCell";
import { ClientsCell } from "./cells/ClientsCell";
import { RoleCell } from "./cells/RoleCell";
import { LastActiveCell } from "./cells/LastActiveCell";
import { ActionsCell } from "./cells/ActionsCell";

export type TeamMemberRow =
    | (OrganizationMember & { type: "member"; id: string | number })
    | (InviteCode & {
          type: "invite";
          inviteAssignments: OrganizationMemberWorkspaceAssignment[];
      });

enum TeamSortValue {
    NAME_ASC = "name_asc",
    NAME_DESC = "name_desc",
    ROLE_ASC = "role_asc",
    ROLE_DESC = "role_desc",
}

export const teamViewConfig: ViewConfig<
    TeamMemberRow,
    TeamColumn,
    TeamSortValue
> = {
    columns: {
        [TeamColumn.USER]: {
            accessorKey: "user",
            name: "User",
            header: "User",
            cell: UserCell,
            immutable: true,
            minSize: 250,
            maxSize: 400,
        },
        [TeamColumn.CLIENTS]: {
            accessorKey: "workspaceAssignments",
            name: "Clients",
            header: "Clients",
            cell: ClientsCell,
            minSize: 200,
            maxSize: 300,
        },
        [TeamColumn.ROLE]: {
            accessorKey: "role",
            name: "Role",
            header: "Role",
            cell: RoleCell,
            minSize: 120,
            maxSize: 150,
        },
        [TeamColumn.LAST_ACTIVE]: {
            accessorKey: "lastActive",
            name: "Last active",
            header: "Last active",
            cell: LastActiveCell,
            minSize: 150,
            maxSize: 200,
        },
        [TeamColumn.ACTIONS]: {
            accessorKey: "actions",
            name: "Actions",
            header: "",
            cell: ActionsCell,
            minSize: 80,
            maxSize: 80,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
